import { GenerateGuidService } from './../services/generate-guid.service';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BackendService } from '../services/backend.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ActivityTrackingService } from '../services/activity-tracking.service';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-activity-tracking',
  template: '',
})
export class ActivityTrackingComponent implements OnInit, OnDestroy{
  private pageNameSubject = new BehaviorSubject<string | null>(null);
  private entryId = '' ;
  private currentPage : string | null = null ;
  sessionId! : string ;
  isBack: boolean  = false;
  activityTrackingService = inject(ActivityTrackingService);
  generateGuidService = inject(GenerateGuidService);

  constructor(protected backend : BackendService, protected router : Router ) {}

  ngOnInit(): void {

    this.activityTrackingService.backButton$.subscribe(back => {
      this.isBack = back;
    });

    if(sessionStorage.getItem('mobile'))
      (window as any).finalExit = this.finalExit.bind(this);

    this.pageNameSubject.subscribe( pageName => {
      if( this.currentPage !== null )
        this.trackActivity('exit', 'navigate');

      this.currentPage = pageName ;
      
      if(this.currentPage !== null)
      {
        this.entryId = this.generateGuidService.generateGUID();
        this.trackActivity('enter');
      }
    });

    //Track leaving the page on refresh or tab close
    window.addEventListener('beforeunload' , this.onBeforeUnload );
  }

  ngOnDestroy(): void {
    if( this.router.getCurrentNavigation()?.extras.state?.['timeout'])
      this.trackActivity('exit', 'timeout');
    else
    {
      if(this.isBack)
        this.trackActivity('exit', 'back');
      else
        this.trackActivity('exit', 'navigate');
    }

    this.pageNameSubject.unsubscribe();
    window.removeEventListener('beforeunload' , this.onBeforeUnload );
  }

  setPageName(pageName : string) {
    this.pageNameSubject.next(pageName);
  }

  getPageName() {
    return this.pageNameSubject.value;
  }

  private trackActivity(action: 'enter' | 'exit', exitType? : 'navigate' | 'back' | 'timeout' | 'reload/close' ) : void {
    let civilId = '';
    let token : any = sessionStorage.getItem('token') || this.router.getCurrentNavigation()?.extras.state?.['token'];
    if(token){
      token = JSON.parse( atob(token.split('.')[1]) );
      civilId = token?.CivilId ;
      this.sessionId = this.sessionId || 'port_' + token?.SID.replace(/-/g, '');
    }
    else
    {
      let tempToken : any = sessionStorage.getItem('tempToken');
      if(tempToken && tempToken != "null")
      {
        tempToken = JSON.parse( atob(tempToken.split('.')[1]) );
        civilId = tempToken?.CId.substring(1);
        this.sessionId = tempToken?.AuthSID;
      }
    }
    //console.log(this.sessionId);
    let app = SessionService.GetApplication;
    console.log(app)
    const payload = {
      JourneyId : app.JourneyTrackingId || sessionStorage.getItem('journeyTrackingId'),
      ProductId : app.ProductID || sessionStorage.getItem('productId'),
      SessionId : this.sessionId,
      EntryId : this.entryId,
      CivilId : civilId || sessionStorage.getItem('civilId'),
      JourneyAppId : app.AppId!,
      ScreenName : this.currentPage,
      Action : action,
      ExitType : exitType || null,
      ClientTimestamp : new Date().toLocaleString('en-US', { timeZone: 'Asia/Riyadh' , year : 'numeric', month : '2-digit', day: '2-digit', hour : '2-digit', minute : '2-digit', second: '2-digit', fractionalSecondDigits: 3 })
    };

    if(action == 'exit')
    {
      this.entryId = '' ;
      this.activityTrackingService.resetBackButtonStatus();
      if(exitType == 'reload/close'){
        this.backend.logUserTrackingEvent(payload);
        return ;
      }
    }
    this.backend.postUserTrackingEvent(payload).subscribe();
  }

  private onBeforeUnload = (event : BeforeUnloadEvent) : void => {
    if(this.currentPage != null)
      this.trackActivity( 'exit', 'reload/close');
  }

  finalExit(){
    console.log('final exit - destroy component');
    this?.ngOnDestroy?.();
  }
}
